import React from "react";
import { Container, Grid } from "semantic-ui-react";

import bg from "../../static/converted/eigensboot_bg-min.jpg";
import Imgmodal from "../imgmodal";

const Eigenesboot = () => (
  <Container id="Eigenesboot" className="main_content">
    <h1>Angeln mit dem eigenen Boot</h1>
    <Grid columns={1}>
      <Grid.Column>
        <Imgmodal img={bg} />
      </Grid.Column>
    </Grid>
    <p>
      Das Angeln mit dem eigenen Boot ist bei uns kein Problem. Wir bieten
      Bootstellplätze, einen Mechaniker und alles was Sie für ihr eigenes Boot
      benötigen.
    </p>
  </Container>
);

export default Eigenesboot;



// WEBPACK FOOTER //
// ./src/components/Eigenesboot/index.js